import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {ApiClient} from '@forlabs/api-bridge';
import {DefaultDataServiceConfig, EntityCollectionServiceElementsFactory, HttpUrlGenerator} from '@ngrx/data';
import {Action, ScannedActionsSubject} from '@ngrx/store';
import {Observable} from 'rxjs';
import {EntityCollectionService, FollowMeDataService} from '../metadata';
import {PatientStep, PatientStepInterface} from './patient-steps.models';


@Injectable()
export class PatientStepCollectionService extends EntityCollectionService<PatientStepInterface> {
  constructor(
    serviceElementsFactory: EntityCollectionServiceElementsFactory,
    @Inject(ScannedActionsSubject) scannedActions$: Observable<Action>,
  ) {
    super(PatientStep, serviceElementsFactory, scannedActions$);
  }
}

@Injectable()
export class PatientStepDataService extends FollowMeDataService<PatientStepInterface> {
  constructor(
    apiClient: ApiClient,
    http: HttpClient,
    httpUrlGenerator: HttpUrlGenerator,
    config?: DefaultDataServiceConfig,
  ) {
    super(PatientStep, apiClient, http, httpUrlGenerator, config);
  }
}
